import { LazyLoader, Typography, tk } from '@sunwebgroup/ui-components';
import { styled } from 'styled-components';
import { AccoList } from './AccoList';
import { useSessionRecorder } from '@/scopes/products/pages/components/RecommendedAccos/hooks';
import { useIntl } from '@/intl';
import { AccoListLoading } from './AccoList/AccoListLoading';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${tk('spacing_2xl')} 0;
  background-color: ${tk('color_semantic_bg_subdued')};
  padding: ${tk('spacing_md')} 0;
  overflow: hidden;

  @media ${tk('mq_tablet')} {
    border-radius: ${tk('radius_extra_large')};
    padding: ${tk('spacing_2xl')};
    overflow: visible;
  }
`;

const HeadingTitle = styled(Typography)`
  margin-bottom: ${tk('spacing_lg')} !important;
  align-self: flex-start;
  padding-left: ${tk('spacing_md')};
  @media ${tk('mq_tablet')} {
    margin-bottom: unset;
  }
`;

export default function RecommendedAccos() {
  const intl = useIntl();
  useSessionRecorder();

  return (
    <Container>
      <HeadingTitle $variant="heading-xl" as="h2">
        {intl.formatMessage({ id: 'recommended_accos_title' })}
      </HeadingTitle>
      <LazyLoader>{({ inView }) => (inView ? <AccoList /> : <AccoListLoading />)}</LazyLoader>
    </Container>
  );
}
